import { useState, useEffect } from 'react';
import { Content, Pagination, Table } from 'components';
// import { Table } from 'antd';
import { styles } from '../styles';
import moment from 'moment';

const SearchedSearchWordList = ({
  filteredWordList,
  selectedSearchWordList,
  onChangeSelectedList,
}) => {
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const handleCheckedSearchWord = (_, checkedItem) => {
    const isExistSearchWord = selectedSearchWordList.some(
      (searchWord) => searchWord.search_word_id === checkedItem.search_word_id
    );
    if (isExistSearchWord) {
      onChangeSelectedList(
        selectedSearchWordList.filter(
          ({ search_word_id }) => search_word_id !== checkedItem.search_word_id
        )
      );
    } else {
      const newSelectedSearchWordList = selectedSearchWordList.concat([
        checkedItem,
      ]);
      onChangeSelectedList(newSelectedSearchWordList);
    }
  };

  const handleCheckedAllSearchWord = (action) => {
    switch (action.type) {
      case 'TOGGLE': {
        setIsCheckedAll((state) => !state);
        return;
      }
      case 'RESET': {
        setIsCheckedAll(false);
        return;
      }
      default: {
        return;
      }
    }
  };

  const handlePagination = (page) => {
    if (currentPage === page) return;
    setCurrentPage(page);
  };

  useEffect(() => {
    if (isCheckedAll) {
      onChangeSelectedList(filteredWordList?.map((searchWord) => searchWord));
    } else {
      onChangeSelectedList([]);
    }
  }, [isCheckedAll]);

  return (
    <Content
      maxWidth={'100%'}
      backgroundColor="none"
      padding={0}
      style={{ marginBottom: 20 }}
    >
      <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
        검색된 추천검색어 총<span>{filteredWordList?.length}</span>건
      </h4>
      <Content maxWidth={'100%'} padding={0} style={{ marginBottom: 20 }}>
        <Table
          isChecked
          pagination={false}
          checkedAll={isCheckedAll}
          checkedList={selectedSearchWordList}
          data={filteredWordList?.slice(
            (currentPage - 1) * 10,
            (currentPage - 1) * 10 + 10
          )}
          minHeight={'auto'}
          columns={[
            {
              title: '추천검색어 번호',
              key: 'search_word_id',
              dataIndex: 'search_word_id',
            },
            {
              title: '추천검색어',
              key: 'search_word',
              dataIndex: 'search_word',
              render: (item) => <span style={{ ...styles.tag }}>{item}</span>,
            },
            {
              title: '등록일',
              key: 'created_at',
              dataIndex: 'created_at',
              render: (item) => moment.unix(item).format('YYYY-MM-DD'),
            },
            {
              title: '수정일',
              key: 'updated_at',
              dataIndex: 'updated_at',
              render: (item) => moment.unix(item).format('YYYY-MM-DD'),
            },
            { title: '노출여부', key: 'is_show', dataIndex: 'is_show' },
            { title: '순서', key: 'order', dataIndex: 'order' },
          ]}
          onChecked={handleCheckedSearchWord}
          onCheckedAll={handleCheckedAllSearchWord}
        />
        <Pagination
          current={currentPage}
          pageSize={10}
          total={filteredWordList?.length}
          onChange={handlePagination}
          style={{ marginTop: 20 }}
        />
      </Content>
    </Content>
  );
};

export default SearchedSearchWordList;
